<template>
  <modal
    title="Add to Loyalty Scheme"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div>
      <p class="text-sm font-semibold" v-if="contactIds.length">
        You have selected {{ contactIds.length }} contact(s)!
      </p>
    </div>
    <div class="py-6">
      <label class="label">Select Loyalty Scheme:</label>
      <!-- <input type="text" class="input" placeholder="Enter" /> -->
      <el-select v-model="loyaltySchemeId" placeholder="Select">
        <el-option
          v-for="scheme in loyaltySchemes"
          :key="scheme.id"
          :label="scheme.loyaltyCategory"
          :value="scheme.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="actions flex justify-between">
      <div>
        <p>Cancel</p>
      </div>
      <div>
        <primary-button
          buttonText="Add"
          :loading="loading"
          @click="addToLoyaltyScheme"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    contact: {
      required: true,
    },
    contactIds: {
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      loyaltySchemes: [],
      loyaltySchemeId: null,
    };
  },
  mounted() {
    this.getAllLoyaltySchemes();
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async getAllLoyaltySchemes() {
      try {
        const response = await this.$_getAllLoyaltySchemes();
        this.logResponse(response);
        this.loyaltySchemes = response.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    async addToLoyaltyScheme() {
      this.loading = true;
      const orgId = localStorage.getItem("organizationId");
      let payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: {
          loyaltySchemeId: this.loyaltySchemeId,
          contactIds: this.contactIds.length
            ? [...this.contactIds]
            : [this.contact.id],
        },
      };
      try {
        const response = await this.$_addToLoyaltyScheme(payload);
        this.logResponse(response);
        this.loyaltySchemeId = null;
        this.generateToast("Added to loyalty scheme successfully!", "success");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
